module.exports = __webpack_public_path__ + "assets/img/9872ee713e3cd214a7412f5f3d4da1f1.png";